import React from "react";

export default function Showdistance({ distanceDetails }) {
  return (
    <section className="route-summary wow fadeIn" data-wow-delay="0.2s">
      <div className="route-summary-point">
        <span className="route-summary-icon route-summary-icon-start">
          <i className="fa fa-map-marker-alt"></i>
        </span>
        <div>
          <small>Pickup</small>
          <strong>{distanceDetails.pickupLocation}</strong>
        </div>
      </div>
      <div className="route-summary-journey">
        <span className="route-summary-line"></span>
        <div className="route-summary-metrics">
          <span>
            <i className="fa fa-road"></i> {distanceDetails.distance}
          </span>
          <span>
            <i className="fa fa-clock"></i> {distanceDetails.duration}
          </span>
        </div>
      </div>
      <div className="route-summary-point route-summary-point-end">
        <span className="route-summary-icon route-summary-icon-end">
          <i className="fa fa-flag-checkered"></i>
        </span>
        <div>
          <small>Delivery</small>
          <strong>{distanceDetails.dropLocation}</strong>
        </div>
      </div>
    </section>
  );
}
